const initial_region = {
    region_data:{

    }
};

export default initial_region